import { render, staticRenderFns } from "./PageProgressBar.vue?vue&type=template&id=3995db37&scoped=true"
import script from "./PageProgressBar.vue?vue&type=script&lang=js"
export * from "./PageProgressBar.vue?vue&type=script&lang=js"
import style0 from "./PageProgressBar.vue?vue&type=style&index=0&id=3995db37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995db37",
  null
  
)

export default component.exports